import type { GifItem } from "@/components/ui/gif-picker";

/** The curated GIF collection the picker offers. Edit this list to change it. */
export const defaultGifs: GifItem[] = [
	// 🔄 Classic Reactions
	{
		id: "thumbs-up",
		url: "https://media.giphy.com/media/111ebonMs90YLu/giphy.gif",
		title: "Thumbs Up",
		tags: ["thumbs", "up", "approve", "yes", "good"],
	},
	{
		id: "celebration",
		url: "https://media.giphy.com/media/g9582DNuQppxC/giphy.gif",
		title: "Celebration",
		tags: ["celebrate", "party", "happy", "yay", "excited"],
	},
	{
		id: "thinking",
		url: "https://media.giphy.com/media/3o7btPCcdNniyf0ArS/giphy.gif",
		title: "Thinking",
		tags: ["think", "hmm", "consider", "wondering"],
	},
	{
		id: "clapping",
		url: "https://media.giphy.com/media/7rj2ZgttvgomY/giphy.gif",
		title: "Clapping",
		tags: ["clap", "applause", "good job", "bravo"],
	},
	{
		id: "laughing",
		url: "https://media2.giphy.com/media/v1.Y2lkPTc5MGI3NjExdHB3azF1dmdodnF0ODBzNTZwcjI3YXgwMzk5a29ydmV1ZTk0dWF5ayZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/ZqlvCTNHpqrio/giphy.gif",
		title: "Laughing",
		tags: ["laugh", "lol", "funny", "haha"],
	},
	// 🙏 Thank You (12 GIFs)
	{
		id: "thank-you-dwight",
		url: "https://media.giphy.com/media/IcGkqdUmYLFGE/giphy.gif",
		title: "Dwight Schrute Thank You",
		tags: ["thank you", "thanks", "dwight", "the office", "emotional"],
	},
	{
		id: "thank-you-colorful",
		url: "https://media.giphy.com/media/MF9wHplBBbqwYiTTEk/giphy.gif",
		title: "Colorful Thank You",
		tags: ["thank you", "thanks", "colorful", "animated"],
	},
	{
		id: "thank-you-keanu",
		url: "https://media.giphy.com/media/fWfowxJtHySJ0SGCgN/giphy.gif",
		title: "Keanu Reeves Bow",
		tags: ["thank you", "thanks", "keanu", "bow", "heartfelt"],
	},
	{
		id: "thank-you-pudgy-penguin",
		url: "https://media.giphy.com/media/kxUc3bdlKbe8v2CQNc/giphy.gif",
		title: "Pudgy Penguin Thank You",
		tags: ["thank you", "thanks", "penguin", "cute", "pudgy"],
	},
	{
		id: "thank-you-pink-flowers",
		url: "https://media.giphy.com/media/RqSZw1cSQxCXhnl8W1/giphy.gif",
		title: "Pink Flowers Thank You",
		tags: ["thank you", "thanks", "danke", "flowers", "pink"],
	},
	{
		id: "thank-you-cat-hug",
		url: "https://media.giphy.com/media/hxERQNWQudqSF1iDnr/giphy.gif",
		title: "Cute Cat Love Hug",
		tags: ["thank you", "thanks", "cat", "hug", "love", "cute", "kawaii"],
	},
	{
		id: "thank-you-david-rose",
		url: "https://media.giphy.com/media/fVtcfEXWQJQUbsF1sH/giphy.gif",
		title: "David Rose Thank You",
		tags: ["thank you", "thanks", "schitts creek", "david rose"],
	},
	{
		id: "thank-you-handwritten",
		url: "https://media.giphy.com/media/mS2DjCw9ec0ytUXoGG/giphy.gif",
		title: "Thank U Handwritten",
		tags: ["thank you", "thanks", "handwritten", "colorful"],
	},
	{
		id: "thank-you-jim",
		url: "https://media.giphy.com/media/M9NbzZjAcxq9jS9LZJ/giphy.gif",
		title: "Jim Thank U",
		tags: ["thank you", "thanks", "michael scott", "the office"],
	},
	{
		id: "thank-you-funny-dog",
		url: "https://media.giphy.com/media/uWlpPGquhGZNFzY90z/giphy.gif",
		title: "Funny Dog Thank You",
		tags: ["thank you", "thanks", "dog", "funny"],
	},
	{
		id: "thank-you-beach",
		url: "https://media.giphy.com/media/pbSt1gcLrGvlJMdKji/giphy.gif",
		title: "Beach Waves Thank You",
		tags: ["thank you", "thanks", "beach", "waves", "summer", "nature"],
	},

	// 🎉 Congratulations (10 GIFs)
	{
		id: "congrats-dwight",
		url: "https://media.giphy.com/media/jJQC2puVZpTMO4vUs0/giphy.gif",
		title: "Dwight Schrute Congratulations",
		tags: ["congratulations", "congrats", "dwight", "the office", "fist pump"],
	},
	{
		id: "congrats-clapping",
		url: "https://media.giphy.com/media/8ZblO3ZD5NMltPaFS2/giphy.gif",
		title: "Animated Clapping Congrats",
		tags: ["congratulations", "congrats", "clapping", "applause", "nice one"],
	},
	{
		id: "congrats-you-deserve-this",
		url: "https://media.giphy.com/media/UDwUHzUGu6jdsWY5pC/giphy.gif",
		title: "You Deserve This",
		tags: [
			"congratulations",
			"congrats",
			"you deserve this",
			"dancing",
			"affirmation",
		],
	},
	{
		id: "congrats-confetti",
		url: "https://media.giphy.com/media/OvJvrm9p1KR4puTALN/giphy.gif",
		title: "Love Confetti Congratulations",
		tags: ["congratulations", "congrats", "confetti", "love", "fun"],
	},
	{
		id: "congrats-graduation",
		url: "https://media.giphy.com/media/3E0XSLmQLK0lVkBG8C/giphy.gif",
		title: "Graduation Confetti",
		tags: ["congratulations", "congrats", "graduation", "confetti"],
	},

	// 👏 Good Job / Well Done (12 GIFs)
	{
		id: "good-job-michael-scott",
		url: "https://media.giphy.com/media/wZXOmCIaY6jdFQQbjl/giphy.gif",
		title: "Michael Thumbs Up",
		tags: ["good job", "well done", "stanley", "the office", "thumbs up"],
	},
	{
		id: "good-job-moodman",
		url: "https://media.giphy.com/media/VhWVAa7rUtT3xKX6Cd/giphy.gif",
		title: "MOODMAN Great Job",
		tags: ["good job", "great job", "nice work", "quality"],
	},
	{
		id: "good-job-spongebob",
		url: "https://media.giphy.com/media/3o7abKhOpu0NwenH3O/giphy.gif",
		title: "SpongeBob Thumbs Up",
		tags: ["good job", "well done", "spongebob", "thumbs up"],
	},
	{
		id: "good-job-rainbow",
		url: "https://media.giphy.com/media/5hgYDDh5oqbmE4OKJ3/giphy.gif",
		title: "Rainbow Good Job Fireworks",
		tags: ["good job", "rainbow", "fireworks", "celebration"],
	},
	{
		id: "good-job-seal-approval",
		url: "https://media.giphy.com/media/8DHAvYbHnJi2WxMOk3/giphy.gif",
		title: "Pudgy Penguin Seal of Approval",
		tags: ["good job", "approved", "ok", "okay", "seal of approval", "penguin"],
	},
	{
		id: "good-job-johnny-rose",
		url: "https://media.giphy.com/media/3ohhwi25ISXC7Z4tMs/giphy.gif",
		title: "Johnny Rose Keep Up Good Work",
		tags: ["good job", "keep up the good work", "schitts creek", "johnny rose"],
	},
	{
		id: "good-job-cookie-monster",
		url: "https://media.giphy.com/media/D2hncA3u88gmeCFeoh/giphy.gif",
		title: "Cookie Monster Clapping",
		tags: [
			"good job",
			"well done",
			"cookie monster",
			"sesame street",
			"clapping",
		],
	},
	{
		id: "good-job-bravocado",
		url: "https://media.giphy.com/media/l4q7TIW8nEZYOJUf6/giphy.gif",
		title: "Cute Avocado Bravocado",
		tags: ["good job", "bravo", "avocado", "cute", "bravocado"],
	},
	{
		id: "good-job-loof-timmy",
		url: "https://media.giphy.com/media/qYGvebgOKGygdQgflY/giphy.gif",
		title: "Loof and Timmy Well Done",
		tags: ["good job", "well done", "loof", "timmy", "clapping"],
	},

	// 🤔 Thinking / Hmm (6 GIFs)
	{
		id: "thinking-cat",
		url: "https://media.giphy.com/media/uUnPYB37kLHvFnH4bi/giphy.gif",
		title: "Thinking Cat Hmm",
		tags: ["thinking", "hmm", "cat", "pondering"],
	},
	{
		id: "thinking-teddy-bear",
		url: "https://media.giphy.com/media/7yNblRfoEho5BhON1s/giphy.gif",
		title: "Confused Teddy Bear",
		tags: ["thinking", "hmm", "confused", "teddy bear", "huh"],
	},
	{
		id: "thinking-pudgy-penguin",
		url: "https://media.giphy.com/media/OJvDJvIGIVx6QSBJhg/giphy.gif",
		title: "Pudgy Penguin Hmmm",
		tags: ["thinking", "hmm", "penguin", "question mark", "pudgy"],
	},

	// 💡 Mind Blown / Wow / Interesting (4 GIFs)
	{
		id: "mind-blown-product-hunt",
		url: "https://media.giphy.com/media/26ufdipQqU2lhNA4g/giphy.gif",
		title: "Mind Blown",
		tags: ["mind blown", "wow", "amazing", "product hunt"],
	},
	{
		id: "wow-rainbow-bridge",
		url: "https://media.giphy.com/media/SB6WQbsi9S9Wydb7qe/giphy.gif",
		title: "Rainbow Bridge Wow",
		tags: ["wow", "amazing", "rainbow", "science"],
	},
	{
		id: "thinking-bobo",
		url: "https://media.giphy.com/media/rjNNXlh4PvczSuC1qu/giphy.gif",
		title: "Bobo Memes Thinking",
		tags: ["thinking", "suspicious", "bobo", "memes"],
	},

	// 💪 You Can Do It / Motivation (10 GIFs)
	{
		id: "motivation-teddy-flex",
		url: "https://media.giphy.com/media/B3zMHJjnbwXWJLuEKS/giphy.gif",
		title: "Teddy Bear Flexing",
		tags: ["you can do it", "motivation", "flex", "good luck", "you got this"],
	},
	{
		id: "motivation-anime-fist",
		url: "https://media.giphy.com/media/FemTGpEZeK27M5fKL4/giphy.gif",
		title: "Anime You Can Do It",
		tags: ["you can do it", "motivation", "anime", "fist pump"],
	},
	{
		id: "motivation-abc",
		url: "https://media.giphy.com/media/HLw7tkI8UuMgjhgVag/giphy.gif",
		title: "ABC You Can Do It",
		tags: ["you can do it", "motivation", "press your luck"],
	},
	{
		id: "motivation-rob-schneider",
		url: "https://media.giphy.com/media/faTOHi0omqCMU/giphy.gif",
		title: "Rob Schneider You Can Do It",
		tags: ["you can do it", "motivation", "rob schneider", "classic"],
	},
	{
		id: "motivation-cat-sign",
		url: "https://media.giphy.com/media/xT9DPIBYf0pAviBLzO/giphy.gif",
		title: "Cute Cat Motivational",
		tags: ["you can do it", "motivation", "cat", "cute", "sign"],
	},
	{
		id: "motivation-pudgy-penguin",
		url: "https://media.giphy.com/media/0Rcmxg6VyLlIMo1Cwr/giphy.gif",
		title: "Pudgy Penguin You Can Do It",
		tags: ["you can do it", "motivation", "penguin", "good luck", "pudgy"],
	},
	{
		id: "motivation-woobles",
		url: "https://media.giphy.com/media/5kIh9jg6olLrZJtAf6/giphy.gif",
		title: "Woobles You Can Do It",
		tags: ["you can do it", "motivation", "cute", "kawaii", "woobles"],
	},
	{
		id: "motivation-thanks-legend",
		url: "https://media.giphy.com/media/vF7UH9MTF8xm3yGCsk/giphy.gif",
		title: "Thanks Legend",
		tags: ["thank you", "thanks", "legend", "motivation"],
	},

	// 👋 Welcome / Hello (10 GIFs)
	{
		id: "welcome-charles",
		url: "https://media.giphy.com/media/XD9o33QG9BoMis7iM4/giphy.gif",
		title: "Brooklyn 99 Charles Welcome",
		tags: ["welcome", "hello", "brooklyn 99", "charles"],
	},
	{
		id: "welcome-team",
		url: "https://media.giphy.com/media/hr4Ljjyj0L9RYlihLr/giphy.gif",
		title: "Welcome to the Team",
		tags: ["welcome", "hello", "team", "onboarding"],
	},
	{
		id: "hello-ralph",
		url: "https://media.giphy.com/media/ASd0Ukj0y3qMM/giphy.gif",
		title: "Ralph Wiggum Waving",
		tags: ["hello", "hi", "wave", "simpsons", "ralph"],
	},
	{
		id: "hello-spongebob",
		url: "https://media.giphy.com/media/g88xUM1rTwjfLhoRYP/giphy.gif",
		title: "SpongeBob Waving Hello",
		tags: ["hello", "hi", "wave", "spongebob"],
	},
	{
		id: "welcome-enthusiastic",
		url: "https://media.giphy.com/media/dZXzmKGKNiJtDxuwGg/giphy.gif",
		title: "Enthusiastic Welcome",
		tags: ["welcome", "hello", "enthusiastic", "excited"],
	},
	{
		id: "welcome-animated",
		url: "https://media.giphy.com/media/TzXweXeJ9d1IhZ5YAy/giphy.gif",
		title: "MeetGenie Welcome",
		tags: ["welcome", "hello", "animated"],
	},
	{
		id: "youre-welcome-andy",
		url: "https://media.giphy.com/media/kmQREsvNQrhrHdkN7G/giphy.gif",
		title: "Andy Bernard You're Welcome",
		tags: ["youre welcome", "the office", "andy bernard"],
	},

	// 😄 Fun / Energy / Celebration (8 GIFs)
	{
		id: "fun-celebration-dance",
		url: "https://media.giphy.com/media/mzZbByY3c3eoqy9CaP/giphy.gif",
		title: "Happy Celebration Dance",
		tags: ["celebration", "dance", "happy", "celebrate"],
	},
	{
		id: "fun-arm-pump",
		url: "https://media.giphy.com/media/H1NIKdfygAAMruqArl/giphy.gif",
		title: "Animated Arm Pump Cheer",
		tags: ["celebration", "cheer", "arm pump", "excited"],
	},
	{
		id: "fun-gold-star",
		url: "https://media.giphy.com/media/lFHtqqh6orvAhbiGmy/giphy.gif",
		title: "Gold Star Well Done",
		tags: ["good job", "well done", "gold star", "fireworks"],
	},
	{
		id: "fun-coderower",
		url: "https://media.giphy.com/media/fNJWzR3aVZzc3tg5Le/giphy.gif",
		title: "CodeRower Well Done",
		tags: ["good job", "well done", "nice work", "coderower"],
	},
	{
		id: "fun-jimmy-fallon",
		url: "https://media.giphy.com/media/cEODGfeOYMRxK/giphy.gif",
		title: "Jimmy Fallon OK Giddy",
		tags: ["ok", "giddy", "jimmy fallon", "excited"],
	},
];
